import { useMemo } from 'react';
import { trpc } from '@/api/trpc';
import { DEFAULT_REQUISITIES_STALE_TIME } from '@/config/constants';
import { useAppQuery, type AppQueryErrorConfig } from './useAppQuery';

/**
 * Shared query for the user's broker connections (no brokerage filter) with
 * the app-standard retry and stale time. Mutations invalidate this query's
 * key explicitly, so the stale time is safe. Call sites that filter by
 * brokerage pass their own input and should keep a direct query.
 */
export const useBrokerConnections = (options?: { enabled?: boolean; errorConfig?: AppQueryErrorConfig }) => {
    const query = useAppQuery(
        {
            ...trpc.user.fetchBrokerConnections.queryOptions(),
            enabled: options?.enabled,
            staleTime: DEFAULT_REQUISITIES_STALE_TIME
        },
        options?.errorConfig
    );

    const brokerConnections = useMemo(() => query.data?.brokerConnections ?? [], [query.data?.brokerConnections]);

    return { brokerConnections, error: query.error, isLoading: query.isLoading, query };
};
